import { render, staticRenderFns } from "./ApplicantBasicInformation.vue?vue&type=template&id=43d154d4&scoped=true&"
import script from "./ApplicantBasicInformation.vue?vue&type=script&lang=js&"
export * from "./ApplicantBasicInformation.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantBasicInformation.vue?vue&type=style&index=0&id=43d154d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d154d4",
  null
  
)

export default component.exports